<template>
  <div class="">
    <h3 class="text-center mt-0 pt-0">Agrupador de programas</h3>

    <v-row>
      <v-col cols="4">
        <!-- <v-combobox
          v-model="gestion"
          :items="gestiones"
          label="Filtrar por gestion"
          :loading="loadingprogramas"
          loader-height="4"
          hide-details
          outlined
          dense
        ></v-combobox> -->

        <v-select
          v-model="gestion"
          :items="gestiones"
          :loading="loadingprogramas || loadingsedes"
          loader-height="4"
          dense
          item-value="id"
          label="Filtrar por gestion"
          prepend-inner-icon="mdi-map-search"
          outlined
        ></v-select>
      </v-col>
      <v-col cols="4" v-if="$store.state.CARGO.id == 17">
        <v-combobox
          v-model="sede"
          :items="sedes"
          label="Filtrar por sede"
          :loading="loadingsedes"
          loader-height="4"
          hide-details
          outlined
          dense
        ></v-combobox>
      </v-col>
      <v-col cols="4"></v-col>
    </v-row>

    <p class="text-center green darken-2 white--text">
      Arrastre los programas del panel izquierdo al panel derecho correspondiente al programa para crear una agrupacion
    </p>
    <!-- <v-btn class="orange darken-2 white--text mb-2" tile @click="crearlista()">Crear nuevo grupo</v-btn> -->

    <div class="caja">
      <div class="panel manito" v-for="(p, ind) in paneles" :key="ind">
        <div class="pa-2 blue darken-4 white--text">
          <v-text-field
            v-if="ind == 0"
            dense
            dark
            v-model="filtrar"
            label="filtrar por nombre:"
            placeholder="_"
            hide-details
            outlined
          ></v-text-field>
          <b>{{ p.titulo }}</b>
          <!--  <b v-if="ind == 0">{{ p.titulo }}</b> -->
          <p class="mb-0">{{ p.programa_ids.length }} items.</p>
        </div>
        <draggable v-model="p.programa_ids" :options="{ group: 'people' }" style="min-height: 5em">
          <div v-for="(item, ind2) in p.programa_ids" :key="ind2">
            <v-card class="mx-auto pa-0 rounded-0" flat outlined v-if="item.xshow">
              <v-list-item three-line>
                <v-list-item-avatar size="60" color="black">
                  <img :src="location_programa_portadas + item.portada" style="border-radius: 50%" />
                </v-list-item-avatar>

                <v-list-item-content>
                  <b>
                    <small> {{ ind2 + 1 }}.- {{ item.nombre_compuesto }} </small>
                  </b>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </div>
        </draggable>
      </div>
    </div>

    <v-progress-linear
      v-if="loading"
      color="green darken-2"
      class="mt-2 mb-0"
      indeterminate
      rounded
      height="6"
    ></v-progress-linear>
    <p class="text-center red--text">{{ msg }}</p>
    <div class="text-center">
      <v-btn class="green darken-4 white--text mt-4" @click="guardar()" :disabled="loading">Guardar Agrupacion</v-btn>
    </div>
  </div>
</template>

<style>
  .caja {
    width: 100%;
    overflow-x: auto;
    white-space: nowrap;
  }
  .panel {
    width: 370px;
    border: 1px solid rgb(165, 185, 230);
    display: inline-block;
    vertical-align: top;
    margin: 0 4px;
  }
</style>

<script>
  import gql from 'graphql-tag';
  import draggable from 'vuedraggable';
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        location_programa_portadas: process.env.VUE_APP_URL_PORTADAS,
        gestiones: [2024,2023, 2022, 2021, 2020, 2019, 2018],
        sedes: [],
        sede: null,
        gestion: null,
        filtrar: null,
        loading: false,
        msg: '',
        loadingprogramas: false,
        loadingsedes: false,
        programas: [],
        paneles: [],
      };
    },
    watch: {
      gestion() {
        this.listarprogramasgraphql();
      },
      sede() {
        this.listarprogramasgraphql();
      },
      filtrar: function(filtro) {
        this.paneles[0].programa_ids.forEach((x) => {
          if (x.nombre_compuesto.includes(filtro)) x.xshow = true;
          else x.xshow = false;
        });
      },
    },
    components: { draggable },
    methods: {
      openmodal(padre = null) {
        this.programas = [];
        if (this.paneles.length > 0) this.paneles[0].programa_ids = [];
        this.paneles = [];
        this.gestion = new Date().getFullYear();
        let paneltodos = {
          id: -1,
          titulo: 'Programas sueltos para agrupar',
          programa_ids: [],
        };
        this.paneles.push(paneltodos);
        if (padre) {
          let panelpadre = {
            id: padre.id,
            titulo: padre.programa,
            programa_ids: [],
          };
          this.paneles.push(panelpadre);
        }
        this.listarprogramasgraphql();
      },
      listarprogramasgraphql() {
        if (!this.sede) return;
        if (!this.paneles[0]) return;
        const vue = this;
        this.programas = [];
        this.paneles[0].programa_ids = [];
        this.loadingprogramas = true;
        this.filtrar = '';
        let idsede = this.sede.id;
        var sql = gql`query{ getProgramas(cursor:1000000,estado:true,gestion:${this.gestion},idsede:${idsede}){ id,plataforma_id, course_category_id,fase,version,grupo,estado,codigo,nombre_compuesto, portada} }`;
        this.$apollo
          .query({ query: sql, variables: { cursor: this.cursor } })
          .then(({ data }) => {
            let datos = data.getProgramas;
            datos.map((x) => {
              x.xshow = true;
            });
            vue.paneles[0].programa_ids = datos;
            vue.loadingprogramas = false;
          })
          .catch(() => {
            vue.loadingprogramas = false;
          });
      },
      crearlista() {
        let paneltodos = {
          id: this.paneles.length,
          titulo: '',
          programas: [],
        };
        this.paneles.splice(1, 0, paneltodos);
      },
      deletelista(panel) {
        panel.programa_ids.forEach((x) => {
          this.paneles[0].programa_ids.push(x);
        });
        panel.programa_ids = [];
        this.paneles = this.paneles.filter((x) => x.id != panel.id);
      },
      getSedes() {
        this.loadingsedes = true;
        const vue = this;
        let sq = 'query { getSedes {   id   nombre }}';
        let sql = gql`
          ${sq}
        `;
        vue.$apollo
          .query({
            query: sql,
          })
          .then(({ data: { getSedes } }) => {
            getSedes.map((x) => {
              x.text = x.nombre;
            });
            vue.sedes = getSedes;
            vue.sede = vue.sedes.find((s) => s.id == vue.$store.state.CARGO.sede.id);
            vue.loadingsedes = false;
          })
          .catch(() => {
            vue.loadingsedes = false;
          });
      },
      guardar() {
        let data = [];
        let valido = true;
        this.msg = '';
        /*this.paneles.forEach((x, i) => {
          let j = { programa_usxx_id: x.id, programa_ids: [] };
          if (x.programa_ids.length == 0) valido = false;
          x.programa_ids.forEach((p) => {
            j.programa_ids.push(p.id);
          });
          if (i > 0) {
            data.push(j);
          }
        });*/
        if (this.paneles.length < 2) {
          this.msg = 'Debe realizar alguna agrupacion para poder guardar.';
          return;
        }
        let x = this.paneles[1];
        let j = { programa_usxx_id: x.id, programa_ids: [] };
        if (x.programa_ids.length == 0) valido = false;
        x.programa_ids.forEach((p) => {
          j.programa_ids.push(p.id);
        });
        data.push(j);
        window.console.log(JSON.stringify(data[0], null, 4));

        if (!valido) {
          this.msg = 'Debe realizar alguna agrupacion para poder guardar.';
          return;
        }

        this.loading = true;
        const vue = this;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/programa/programa-usxx/add`;
        xaxios
          .patch(url, data[0])
          .then((res) => {
            vue.msg = res.data.result;
            vue.loading = false;
            vue.dialog = false;
            vue.$emit('xnewagrupacion', vue.msg);
          })
          .catch((error) => {
            window.console.error(error);
            if (error.response) vue.msg = error.response.data.error;
            else vue.msg = error;
            vue.loading = false;
          });
      },
    },
    mounted() {
      this.getSedes();
    },
  };
</script>
